import { DonationSettingsView, UpdateDonationSettingsInput } from '../../donation.js';
export const donationRoutes = {
    settings: {
        method: 'GET',
        path: '/me/donations',
        response: DonationSettingsView,
    },
    updateSettings: {
        method: 'PUT',
        path: '/me/donations/settings',
        body: UpdateDonationSettingsInput,
        response: DonationSettingsView,
    },
};
//# sourceMappingURL=routes.js.map